import { useEffect } from "react";
import i18n from "../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import ET3PageDiv from "../../../core/et3-page-div";
import Et3PageTitle from "../../../core/et3-page-title/index";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import ChangeStatusForm from "./change-statu-form";

const ChangeStatus = withLiteObserverAndTheme(() => {
  useEffect(() => {
    getCoreHistoryStore().setPageName(
      "QA_CHANGE_STATUS_DATE",
      "QA_CHANGE_STATUS_DATE"
    );
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("QA")}
        subTitle={i18n.get("USER_STATUS_DATE")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <ChangeStatusForm />
    </ET3PageDiv>
  );
});

export default ChangeStatus;
